module.exports = __webpack_public_path__ + "static/media/conservatoire.afc0a66c.jpg";